const styles = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  flexGrow: 1,
};

export default styles;
